"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toStableObject = exports.hexToUint8Array = exports.fakeEthProvider = exports.fakeIpfs = exports.sha256Multihash = exports.unpad = exports.pad = void 0;
const js_sha256_1 = require("js-sha256");
const multihashes_1 = __importDefault(require("multihashes"));
const ipld_dag_cbor_1 = __importDefault(require("ipld-dag-cbor"));
const fast_json_stable_stringify_1 = __importDefault(require("fast-json-stable-stringify"));
const ENC_BLOCK_SIZE = 24;
exports.pad = (val, blockSize = ENC_BLOCK_SIZE) => {
    const blockDiff = (blockSize - (val.length % blockSize)) % blockSize;
    return `${val}${'\0'.repeat(blockDiff)}`;
};
exports.unpad = (padded) => padded.replace(/\0+$/, '');
exports.sha256Multihash = (str) => {
    return multihashes_1.default.encode(Buffer.from(js_sha256_1.sha256(str)), 'sha2-256').toString('hex');
};
let tmpData;
exports.fakeIpfs = {
    dag: {
        put: (data, opts) => {
            tmpData = data;
            return ipld_dag_cbor_1.default.util.cid(ipld_dag_cbor_1.default.util.serialize(data), opts);
        },
        get: () => ({ value: tmpData }),
    },
    add: () => 'empty',
};
exports.fakeEthProvider = (wallet) => ({
    send: (request, callback) => {
        if (request.method !== 'personal_sign') {
            callback(new Error('only supports personal_sign'));
        }
        else {
            let message = request.params[0];
            if (message.startsWith('0x')) {
                message = Buffer.from(message.slice(2), 'hex').toString('utf8');
            }
            callback(null, { result: wallet.signMessage(message) });
        }
    },
});
function hexToUint8Array(str) {
    return new Uint8Array(Buffer.from(str, 'hex'));
}
exports.hexToUint8Array = hexToUint8Array;
function toStableObject(obj) {
    return JSON.parse(fast_json_stable_stringify_1.default(obj));
}
exports.toStableObject = toStableObject;
